import { render, staticRenderFns } from "./culturalTourDetail.vue?vue&type=template&id=1ce5dc10&scoped=true&"
import script from "./culturalTourDetail.vue?vue&type=script&setup=true&lang=js&"
export * from "./culturalTourDetail.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./culturalTourDetail.vue?vue&type=style&index=0&id=1ce5dc10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce5dc10",
  null
  
)

export default component.exports